export default __webpack_public_path__ + "static/media/Wall Reader Modular.c41c573a.jpg";